import React from 'react';
const FinalCTA = () => {
  return <section className="py-20 bg-gradient-to-b from-amber-50 to-white" data-id="element-102">
      <div className="container mx-auto px-4" data-id="element-103">
        <div className="max-w-3xl mx-auto text-center" data-id="element-104">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-800" data-id="element-105">
            Tu cocina puede ser más rápida, organizada y deliciosa desde hoy
            mismo
          </h2>
          <div className="mb-8" data-id="element-106">
            <p className="text-lg text-gray-600" data-id="element-107">
              Transforma tus cenas en momentos deliciosos sin estrés, ahorrando
              tiempo y dinero
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-center mb-6" data-id="element-108">
            <a href="https://pay.hotmart.com/W101891326K?checkoutMode=10" className="bg-white text-custom-brown hover:bg-custom-brown hover:text-white border border-custom-brown font-bold py-4 px-10 rounded-lg text-xl transition duration-300 shadow-lg" onClick={() => {
            if (window.fbq) window.fbq('track', 'AddToCart', {
              content_name: '7 Cenas Latinas en 30 Minutos',
              content_type: 'product',
              value: 7.0,
              currency: 'USD'
            });
          }} data-id="element-109">
              Empieza hoy mismo, sin riesgo - $7.00
            </a>
          </div>
          <p className="text-custom-brown font-medium" data-id="element-110">
            <del className="text-gray-500" data-id="element-111">$83</del> - ahorras $77
          </p>
          <p className="text-custom-brown font-medium mt-2" data-id="element-112">
            Oferta de lanzamiento con 3 bonos gratis, disponible solo por tiempo
            limitado.
          </p>
        </div>
      </div>
    </section>;
};
export default FinalCTA;